import { Button, Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { Message } from "src/app/types/Message";
import { toAbsoluteUrl } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
import moment from "moment";
import { useField } from "formik";
import { useEffect, useRef } from "react";
import CkEditorCustom from "../CkEditorCustom/CkEditorCustom";
import ShadowDOM from "../ShadowDOM/ShadowDOM";
import { useMessageTagsOptions } from "src/app/hooks";
import { SimpleFormSelect } from "../form/SimpleFormSelect";

export interface IViewMessageCenterForm {
    entity: Message;
    formId: string;
    handleMessageFiles(filename: string): void;
}

const ViewMessageCenterForm = (props: IViewMessageCenterForm) => {
    const { entity, handleMessageFiles, formId } = props;

    const chatWrapper = useRef<HTMLInputElement>(null);
    const { formatMessage } = useIntl();
    const { tagsOptions } = useMessageTagsOptions();

    const [, textMetaProps, textHelperProps] = useField(`newMessage`);
    const [tagProps, ,] = useField("tag");

    useEffect(() => {
        if (chatWrapper?.current) {
            chatWrapper.current.scrollTop = chatWrapper.current.scrollHeight;
        }
    }, []);

    return (
        <div className="viewMessageCenterFormWrapper">
            <Row className="mb-4">
                <Col sm={3}>
                    <b>{formatMessage({ id: "common.field.moneySite" })} :</b>{" "}
                    {entity.moneySite.domain} ({entity.moneySite.pbn.name}) |{" "}
                    <b>{formatMessage({ id: "common.field.tag" })} :</b> {tagProps.value}
                </Col>
                <Col sm={12}>
                    <b>{formatMessage({ id: "common.field.subject" })} :</b>{" "}
                    {entity.subject.replaceAll(" ", "_")}
                </Col>
            </Row>

            <Row className="mb-4 mt-4" style={{ height: "98%" }}>
                <Col sm={8} style={{ height: "100%" }}>
                    <div ref={chatWrapper} className="chatWrapper">
                        {entity.chat?.map((chat, key) => (
                            <Row key={key} className="mb-4">
                                {chat?.mailFrom !== entity.mailFrom && <Col sm={4}></Col>}
                                <Col sm={8}>
                                    <div
                                        className={`p-4 rounded ${
                                            chat?.mailFrom === entity.mailFrom
                                                ? "message-received"
                                                : "message-sent"
                                        }`}
                                        style={{
                                            overflowY: "auto",

                                            border: "1px solid var(--kt-input-border-color)",
                                        }}
                                    >
                                        <ShadowDOM innerHTML={chat?.message} />
                                    </div>
                                    <Row>
                                        <Col>
                                            {moment(chat?.receivedAt).format("DD/MM/YY HH:mm:ss")}{" "}
                                            <b>{formatMessage({ id: "common.field.mailFrom" })}</b>{" "}
                                            {chat?.mailFrom}
                                        </Col>
                                        {chat?.attachments && (
                                            <Col>
                                                <div className="d-flex flex-row gap-2">
                                                    {chat.attachments.map((att, index) => {
                                                        return (
                                                            <div
                                                                onClick={() =>
                                                                    handleMessageFiles(att)
                                                                }
                                                                key={index}
                                                                className="attachments"
                                                            >
                                                                <SVG
                                                                    fill="var(--kt-text-danger)"
                                                                    width="16px"
                                                                    src={toAbsoluteUrl(
                                                                        "/media/icons/duotune/communication/com008.svg"
                                                                    )}
                                                                />
                                                                <span>{att?.split("*")[1]}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </Col>
                                {chat?.mailFrom === entity.mailFrom && <Col sm={4}></Col>}
                            </Row>
                        ))}
                    </div>
                </Col>
                <Col sm={4}>
                    <CkEditorCustom
                        data={textMetaProps.value}
                        onReady={(editor) => {
                            const data = editor.getData();
                            textHelperProps.setValue(data);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            textHelperProps.setValue(data);
                        }}
                    />
                    <div className="buttonWrapper">
                        <div className="tagOptionsWrapper">
                            <label>
                                {formatMessage({
                                    id: "common.field.placeholder.tag",
                                })}
                            </label>

                            <SimpleFormSelect
                                name="tag"
                                values={tagsOptions}
                                tagPlaceholder={formatMessage({
                                    id: "common.field.placeholder.tag",
                                })}
                            />
                        </div>
                        <Button type="submit" form={formId}>
                            {formatMessage({ id: "common.action.send" })}
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ViewMessageCenterForm;
